/**
 * VAT API endpoints
 */
import apiClient from './config/axios';

export const vatApi = {
    /**
     * Get the active VAT rate for price calculations
     * @returns {Promise<{success: boolean, data: {id: number, vatRate: number, isActive: boolean}}>}
     */
    getActiveVatRate: async () => {
        try {
            const response = await apiClient.get('/api/vat/active/rate');
            return response.data;
        } catch (error) {
            console.error('Error fetching active VAT rate:', error);
            return {
                success: false,
                data: { vatRate: 0 },
                message: error.response?.data?.message || 'Failed to fetch VAT rate',
            };
        }
    },
};
